














import { Component, Prop, Vue } from 'vue-property-decorator'
import { SourceCodeServiceRepository } from '@/services/sourceCode/SourceCodeService'
import UserRepositoryHeader from '@/components/UserRepositoryHeader/index.vue'
import Button from '@/components/Button/index.vue'
import { openExternalLink } from '@/router'

@Component({
  components: {
    UserRepositoryHeader,
    Button
  }
})
export default class UserRepository extends Vue {
  @Prop(Object) readonly repository!: SourceCodeServiceRepository

  get description(): string {
    return this.repository.description || 'no description'
  }

  handleOpenRepository(): void {
    openExternalLink(this.repository.url)
  }
}
